import React from 'react'
import PlayerCardBack from '../card-collection-components/PlayerCardBack'
import mybtn from './images/mybtn.png'
import Fab from '@mui/material/Fab';
const Instructions = (props) => {
    return (
        <div className="instructions-section" >
            <div style={{direction:"ltr"}}><h1 style={{color:"White"}}>How to Play ?</h1>
            <p className="instruction-box glass">
                Rules of the game are simple. You are randomly alloted a deck of 8 cards. It's a turn based game so at the start of each round either you or your opponent gets to select a stat. Whoever has higher stat wins the round. In the end, one with zero cards left loses. For each round you lose, your card gets transferred to your opponent and vice versa.
            </p>
            <div className="instruction-box glass">Tap on the card to see its stats. Select a stat that you think can win the round for you.
            <div className="instruction-player-card-back"><PlayerCardBack player={props.player} gameMode={true} />
            </div>
            <div>Press Select to confirm your selection and wait for opponent to select card</div>
            </div>
         
            
            <div className="instruction-box glass">If you win, you get to select a card and its stat again.
             If you lose then you have to let the opponent select the stat.
            Tap <span> <img className="insbtn" src={mybtn}/></span> button to let the opponent select first when you lose.</div>
            </div>
            <div style={{display:(props.isMobile?"auto":"none")}} class="fixed-centre-modal-close"><Fab onClick={props.close} variant="extended" color="secondary"><div style={{fontSize:"21px"}}>× Close</div></Fab> </div></div>
    )
}

export default Instructions
